/**
 * Created by karthikeyan on 10-02-2022.
 */
import { PipeTransform, Pipe } from '@angular/core';
import { UtilService } from 'src/app/util/UtilService';
@Pipe({
    name: 'replaceyear',
    standalone: false
})
export class ReplaceYearPipe implements PipeTransform {
  constructor(public utilservice: UtilService) {}

  transform(nStr: string) {
    return nStr.replace('2020', this.utilservice.currentYear);
  }
}
